import {Injectable} from '@angular/core';


import {Observable} from 'rxjs';
import {NotificationData} from '../../types/notification/notification-data';
import {SystemType} from '../../types/common/system-type';
import {LocalizedValue} from '../../types/standard/localized-value';
import {BaseRestService} from '../common/BaseRestService';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable()
export class NotificationRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('notifications');
  }

  getNotifications(type: SystemType): Observable<NotificationData[]> {
    const params: HttpParams = new HttpParams()
      .set('type', SystemType[type]);

    return this.http.get(this.getEndpoint(), {params})
      .pipe(
        map(this.toNotificationData.bind(this))
      );
  }

  private toNotificationData(rsp: any): NotificationData[] {
    const data: NotificationData[] = [];
    for (const nd of rsp) {
      const notificationData = new NotificationData(nd.notificationType, [], []);
      notificationData.subject = this.toLocalizedValues(nd.subject);
      notificationData.body = this.toLocalizedValues(nd.body);
      data.push(notificationData);
    }
    return data;
  }

  private toLocalizedValues(lvs: any): LocalizedValue[] {
    const values: LocalizedValue[] = [];
    const filtered = lvs.filter(l => !['ar_AE', 'ru_RU'].includes(l.langCode));
    for (const lv of filtered) {
      values.push(new LocalizedValue(lv.id, lv.langCode, lv.value));
    }
    return values;
  }

  updateNotification(notification: NotificationData): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post(this.getEndpoint(), notification, { headers })
      .pipe(
        map(this.extractData)
      );
  }

  private extractData(res: Response) {
    let body;
    // check if empty, before call json
    if (res) {
      body = res.json();
    }
    return body || {};
  }

}
